<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<is-wait-message [loadComplete]="isLoadComplete" [useBolt]="false"></is-wait-message>
<h1 class="page-indicator h1-compensate">
    <div class="claims-track-page-title-wrap claims-track-page-title--overview">
        Package (PAK) Claims
        <small class="claims-track-company" style="text-transform:uppercase;">{{package?.policyAccount?.namedInsuredName}}</small>
        <small class="claims-track-number">PAK Number:
            <em>{{package?.policyAccount?.prefixA}}{{package?.policyAccount?.branchNumber +
                package?.policyAccount?.decNumber +
                package?.policyAccount?.policyNumber}}
            </em>
        </small>
    </div>
</h1>

<div class="content-container-light-blue bolt-space-bottom-sm">
    <!-- TODO - Maybe move static content to tridion, check with business -->

    <p class="pak-intro-text">
        Your PAK consists of multiple types of policies. We've listed each policy so that you may file a claim or access
        claim details
        for each one.
        <br>
        <br> New claims may take 24 – 48 hours to appear.
    </p>
    <main role="main" class="content-container-light-blue__inner">
        <div class="claims-track-claim-content__text-box  dark-gray-text tile-spacing">
            <is-search-claim></is-search-claim>
        </div>
        <div *ngFor="let policy of package?.policies; let policyIndex = index">
            <is-policy-section [policy]="policy" [lossCauseList]="claimsDataService.lossCauseTypes" [accountNumber]="accountNumber" [allClaimsList]="allClaimsList" *ngIf="allClaimsList"></is-policy-section>
        </div>
    </main>
</div>

<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
